module.exports = __webpack_public_path__ + "static/media/buy_req_make_4.577f15fc.jpg";